
import { defineComponent, ref, computed, onMounted } from 'vue';
import { useStore, ActionTypes, Todo } from "../store";
import { format } from 'date-fns'

enum FilterTypes {
  ALL = 'ALL',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED'
}

export default defineComponent({
  name: 'Todo',

  props: {},

  setup() {
    const store = useStore();
    const description = ref('');
    const todoType = ref('ALL')

    const submitTodo = (): void => {
      if (!description.value) {
        return;
      }

      store.dispatch(ActionTypes.ADD_TODO, {description: description.value, isComplete: false, createdAt: format(new Date(), 'MM/dd/yyyy'), completedAt: ''})
      description.value = '';
    }

    const completeTodo = (todo: Todo): void => {
      store.dispatch(ActionTypes.COMPLETED_TODO, todo)
    }

    const todos = computed(() => {
      if(todoType.value === FilterTypes.ALL) {
        return store.state.todos
      } else if ( todoType.value === FilterTypes.COMPLETED) {
        return store.state.todos.filter(item => item.isComplete)
      } else if (todoType.value === FilterTypes.ACTIVE) {
        return store.state.todos.filter(item => !item.isComplete)
      }
    });

    const boom = (type: string): void => {
      todoType.value = type
    }



    const itemsLeft = computed(() => {
      const todos = store.state.todos;
      return `${todos.filter(item => !item.isComplete).length} items left`
    })

    onMounted(() => {
      store.dispatch(ActionTypes.GET_TODOS);
    })

    return {
      todos,
      description,
      submitTodo,
      completeTodo,
      itemsLeft,
      boom
    }
  }
});
